<template src='./productConfiguration.html'>
    
</template>
<script>
import { orderBy } from "@progress/kendo-data-query";
// import { createNamespacedHelpers } from "vuex";
// const { mapState } = createNamespacedHelpers("product");
import CommandCell from '@/components/CommandCellTemplate.vue';
import DialogBox from "@/components/DialogBox.vue";
import AuditLog from "@/components/AuditLog.vue";

export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      search: "",
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      sort: [{ field: "id", dir: "asc" }],
      columns: [
        { field: "code", title: "Product Code" },
        { field: "name", title: "Name" },
        { field: "description", title: "Description"},
        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      removeData:{},
      currentPage: 1,
      productId: null,
      auditLogPageSize: 4
    };
  },
  components: {
    DialogBox,
    AuditLog
  },
  methods: {
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function() {
      this.add = true;
    },
    remove: function(item) {
      this.removeData = item;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      return this.$store.dispatch("product/removeProduct", this.removeData.dataItem);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    edit: function(item) {
      return this.$store.dispatch("product/editProduct", item.dataItem); //item.dataItem.id
    },
    goToAddPage: function(){
      this.$router.push({name: "AddProduct", params: {add: true }})
    },
    async getDataOnload() {
      this.$store.dispatch("getProduct");
    },
    async getAuditLogs(dataItem){
      this.currentPage = 1;
      this.productId = dataItem.dataItem.id;
      await this.$store.dispatch('product/getAuditLogs', {productId: this.productId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
    },
    async auditPagination(currentPage){
      if(this.currentPage != currentPage){
        this.currentPage = currentPage;
        await this.$store.dispatch('product/getAuditLogs', {productId: this.productId, pageSize: this.auditLogPageSize, pageNo: this.currentPage})
      }
    }
  },
  computed: {
    //  ...mapState({
    //   productList: state => state.products,
    // }),
    auditLogs(){ 
      return this.$store.state?.product?.auditLogs ? this.$store.state.product.auditLogs : []
    },
    totalAuditLogs(){
      return this.$store.state?.product?.totalAuditLogs ? this.$store.state.product.totalAuditLogs : 0;
    },
    productList() {
      return this.$store.state.products
    },
    total() {
      if(this.search){
        return this.items ? this.items.length : 0;
      }
      else{
        return this.productList ? this.productList.length : 0;
      }
    },
    items: {
      get: function() {
        if(this.search){
          let data = this.productList.filter(product => `${product.name}`.match(new RegExp(this.search, "i")))
          return orderBy(data.slice(this.skip, this.take + this.skip), this.sort);
        }else{
          return orderBy(this.productList.slice(this.skip, this.take + this.skip), this.sort);
        }
      }
    },

  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
